// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-box {
    position: absolute;
    top: 50px;
    right: 10px;
    width: 250px;
    background-color: #222;
    color: white;
    padding: 10px;
    border-radius: 5px;
    display: none;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }
  
  .notification-box.open {
    display: block;
  }
  
  .notification-content {
    text-align: center;
    padding: 10px 0;
  }`, "",{"version":3,"sources":["webpack://./src/styles/NotificationBox.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,yCAAyC;EAC3C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB","sourcesContent":[".notification-box {\n    position: absolute;\n    top: 50px;\n    right: 10px;\n    width: 250px;\n    background-color: #222;\n    color: white;\n    padding: 10px;\n    border-radius: 5px;\n    display: none;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  }\n  \n  .notification-box.open {\n    display: block;\n  }\n  \n  .notification-content {\n    text-align: center;\n    padding: 10px 0;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
